import { cloneElement, isValidElement, ReactElement } from 'react';
import { TransInterpolation } from './types';

export type TransProps = TransInterpolation & {
  children: string;
};

function trans(word: string, props: TransInterpolation): any {
  const keys = Object.keys(props);

  if (!keys.length) {
    return [word];
  }

  const [key] = keys;
  const result = word.split(`{{${key}}}`);
  const rest = { ...props };
  delete rest[key];

  return result.reduce((prev, current) => {
    if (!prev.length) {
      return trans(current, rest);
    }

    const prop = props[key];
    const value = isValidElement(prop) ? cloneElement(prop, { key }) : prop;

    return [...prev, value, ...trans(current, rest)];
  }, []);
}

/**
 * A component to resolve props as interpolation.
 * The children prop should be `string`.
 *
 * @example
 *
 * <Trans
 * 	name={(
 * 		<br>
 * 			SurveyCake
 * 		</br>
 * 	)}
 * >
 * 	{'Hi, my name is {{name}}'}
 * </Trans>
 */
export function Trans({ children, ...props }: TransProps): ReactElement | null {
  return trans(children, props);
}
